import BonusBuyWheelComponent from "components/bonus-wheel/bonus-wheel";
import FreespinsMediator from "mediators/freespins-mediator";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { parallel, sequence } from "slotworks/utils/race-utils";

export default class RecoveryBonusWheel extends State {

    public onEnter() {        
        regulation.interactionStart();
        
        if(gameState.getCurrentGame().records[0] instanceof FreespinRecord) {
            gameState.getCurrentGame().inFreespinsGame = true;

            Components.betBar.setBetOptions(betModel.generateBetOptions());
            Components.betBar.setType(BetBarType.FREESPINS);
            new FreespinsMediator().start().execute();

            Components.betBar.setEnabled(false);
            Components.betBar.winnings.setWinnings(0, gameState.getCurrentGame().getRunningFreespinsWinTotal() - gameState.getCurrentGame().getCurrentRecord().creditsWon);
            this.recoverFreespinsElements();
        }

        const bonuswheel = new BonusBuyWheelComponent();
        bonuswheel.start(true).then(() => {
            if (gameState.getCurrentGame().inFreespinsGame) {
                sequence([
                    () => parallel([
                        () => Layers.Custom.get("Transition").setScene("fs"),
                        () => Contract.wrap(() => bonuswheel.exitBonus())
                    ]),
                    () => Layers.Custom.get("Transition").defaultScene(),
                ]).then(() => this.complete());
            } else {
                this.complete();
                bonuswheel.exitBonus();
            }
        });
    }

    protected recoverFreespinsElements() {
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.jumpToScene("freespins");
        }

        Components.banner.setMode("freespins");
    }
}